const initialState =
{
    isPollOpen: false,
    polls: [],
    result: [],
    noPeerAlreadyAnswer: 0,
    isPollEnd: true,
};

const poll = (state = initialState, action) => {
    switch (action.type) {
        case 'OPEN':
            {
                return { ...state, isPollOpen: action.payload.isPollOpen };
            }
        case 'RESET_POLL_LIST':
            {
                
                return { ...state, polls: action.payload.polls };
            }
        case 'ADD_POLL':
            {
                
                const currentPoll = action.payload.poll;
                const newPoll = [...state.polls];
                const index = newPoll.findIndex((p) => p.id === currentPoll.id);
                if (index === -1) {
                    newPoll.push(currentPoll);
                } else {
                    newPoll[index] = currentPoll;
                }
               
                return { ...state, polls: newPoll };
            }

        case 'LAUNCH_POLL':
            {
                return { ...state, launchPoll: action.payload, isPollOpen: !!action.payload.poll.id, isPollEnd: false };
            }
        case 'SHOW_RESULT':
            {
                return { ...state, isShowResult: action.payload.isShowResult, isPollEnd: true };
            }
        case 'END_POLL':
            {
                return { ...state, isPollEnd: action.payload };
            }
        case 'ANSWER_POLL':
            {
                return { ...state, launchPoll: action.payload, result: action.payload.newResult, noPeerAlreadyAnswer: action.payload.noPeerAlreadyAnswer };
            }
        case 'ATTENDEE_RESULT_PUBLISH':
            {
                return { ...state, launchPoll: action.payload, noPeerAlreadyAnswer: action.payload.noPeerAlreadyAnswer };
            }
        case 'FORCE_CLOSE':
            {
                return {
                    ...state,
                    launchPoll: undefined,
                    noPeerAlreadyAnswer: 0,
                    isShowResult: false,
                    isPollOpen: false,
                    isPollEnd: false,
                    result: [],
                };
            }
        default:
            return state;
    }
};

export default poll;
